import React, { FC } from 'react'
import { SearchField, Typography } from '@telavita-core/react-design-kit'
import * as S from './style'
import { SearchFieldProps } from '@telavita-core/react-design-kit/build/components/SearchField/SearchField'

export interface CustomSearchFieldProps extends SearchFieldProps {
  label?: string
  description?: string
}

export const CustomSearchField: FC<CustomSearchFieldProps> = ({
  label,
  description,
  ...searchFieldProps
}) => {
  return (
    <S.Container>
      <S.TitleContainer>
        {label && (
          <Typography weight='bolder' variant='content2'>
            {label}
          </Typography>
        )}
        {description && (
          <Typography variant='content3'>{description}</Typography>
        )}
      </S.TitleContainer>
      <SearchField {...searchFieldProps} />
    </S.Container>
  )
}
